import React from 'react';
import './arrow.scss';

type arrowProps = {
    direction: string,
    clickHandler: any
}

const Arrow = ({direction, clickHandler}: arrowProps) => {  
    return(
      <div className='arrow' onClick={clickHandler} id= {direction === 'left' ? 'left-arrow-button' : 'right-arrow-button'}>
        <img src={direction === 'left' ? '/images/left-arrow.svg' : '/images/right-arrow.svg'} 
          className=""
          alt={direction === 'left' ? 'left' : 'right'} />
      </div>
    );
}

export default Arrow;

